// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Cruces__tabsContainer__DwSez","myCol":"Cruces__myCol__1JzV9","myCol2":"Cruces__myCol2__IjIJq"};